// Usar template strings para queries GraphQL (compatible con fetch nativo)
import { contentfulClient } from './graphqlClient'
import { OnboardingQueryResponse } from '../types/onboarding.types'

export const ONBOARDING_QUERY = `
	query contenido {
		homeCollection(limit: 1, where: { titulo: "Salud continua" }) {
			items {
				vistas {
					onbording {
						tituloGeneral
						descripcionGeneral
						beneficioCollection(limit: 10) {
							items {
								idReto
								textoBoton
								tituloGeneral
								descripcionGeneral
								tituloCard
								imagen {
									url
								}
								numeroDelReto
								beneficioCollection(limit: 10) {
									items {
										tituloGeneral
									}
								}
							}
						}
					}
				}
			}
		}
	}
`

export const onboardingApi = {
	getOnboarding: async (): Promise<OnboardingQueryResponse> => {
		try {
			const data = await contentfulClient.request(ONBOARDING_QUERY)
			return data
		} catch (error) {
			console.error('Error al obtener datos de onboarding:', error)
			throw error
		}
	}
}
